import { h } from "preact";
import { classNames, renderHtml, replaceRedactions } from "../helpers";
import uniq from "lodash/uniq";

import i18n from "../i18n";
import { getPositionFromUser } from "../talentHelpers";

import Tag from "./Tag.jsx";
import TalentState from "./TalentState.jsx";
import CountryFlag from "./CountryFlag.jsx";
import RedactedInfo from "./RedactedInfo.jsx";
import Tooltip from "./Tooltip.jsx";
import AppliedIcon from "./AppliedIcon.jsx";

export default function TalentShortView({
  previewMode,
  user,
  talent,
  ...props
}) {
  const skills =
    user.skills === null || Array.isArray(user.skills)
      ? user.skills
      : [user.skills];
  const position = getPositionFromUser(user);

  function prepareSkills(skills) {
    return uniq(skills)
      .sort()
      .filter(
        (skill) => !user.topSkills.find((topSkill) => topSkill.name === skill)
      );
  }

  return (
    <div class={classNames("talent-short-view", props.class)}>
      <h2 class="talent-short-view__title" data-testid="username">
        {previewMode ? <RedactedInfo large w256 /> : user.name}
        {talent && (
          <TalentState
            class="talent-short-view__state hide-on-small"
            talent={talent}
          />
        )}
        <AppliedIcon user={user} class="hide-on-small" />
      </h2>

      {(position || user.country) && (
        <p class="t-body3 mt-0 mb-32" data-testid="pos-country">
          {position && (
            <span class="talent-short-view__position">
              {renderHtml(replaceRedactions(position), "span")}
            </span>
          )}
          {position && user.country && ", "}
          {user.country && (
            <span class="talent-short-view__country">
              {user.country}{" "}
              {user.countryCode && (
                <CountryFlag
                  code={user.countryCode}
                  class="ml-8"
                  data-tooltip-id={`country-flag-${user.id}`}
                />
              )}
              {user.countryCode && (
                <Tooltip
                  className="nioomi-tooltip"
                  id={`country-flag-${user.id}`}
                  place="bottom"
                >
                  {i18n.t("component.talent_short_view.country_flag_tooltip")}
                </Tooltip>
              )}
            </span>
          )}
        </p>
      )}
      {user.yearsOfWorkExperience !== null && (
        <p class={"t-body3 mb-24"}>
          {i18n.t("component.talent_short_view.years_of_experience")}
          {" • "}
          <span class="talent-short-view__years">
            {i18n.t("component.talent_short_view.years", {
              count: user.yearsOfWorkExperience,
            })}
          </span>
        </p>
      )}
      {((user.topSkills && user.topSkills.length > 0) ||
        (skills && skills.length > 0)) && (
        <div>
          {i18n.t("component.talent_short_view.skills")}
          <br />
          {sortTopSkill(user.topSkills).map((skill) => (
            <Tag
              grey
              noHover
              class={`mr-12 mt-8 tag--skill-${skill.value * 10}`}
              tooltip={
                skill.value
                  ? i18n.t(`questions.top_skills.values.${skill.value}`)
                  : null
              }
            >
              {skill.name}
            </Tag>
          ))}

          {prepareSkills(skills).map((skill) => (
            <Tag noHover grey cass="mr-12 mt-8">
              {skill}
            </Tag>
          ))}
        </div>
      )}
    </div>
  );
}

function sortTopSkill(skills) {
  return skills.sort((a, b) => {
    if (b.value === a.value) {
      return a.name.localeCompare(b.name);
    }
    return b.value - a.value;
  });
}
